/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const meatRelationship = useStore((state) => state.meatRelationship);
  const setMeatRelationship = useStore((state) => state.setMeatRelationship);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.meatRelationship.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={meatRelationship}
          onChange={(value) => {
            setMeatRelationship(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'meat-relationship',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'love'}>
            <span>❤️</span> {t('onboarding.meatRelationship.options.love')}
          </Option>
          <Option value={'rarely'}>
            <span>🍗</span> {t('onboarding.meatRelationship.options.rarely')}
          </Option>
          <Option value={'never'}>
            <span>🚫</span> {t('onboarding.meatRelationship.options.never')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
